export enum SpriteMap {
  SharingCoverageIcon = 'sharing_coverage_icon',
  PhoneIcon = 'phone_icon',
  LaptopIcon = 'laptop_icon',
  ModulesIcon = 'modules_icon',
  HardwareIcon = 'hardware_icon',
  TreeIcon = 'tree_icon',
  RowByRowIcon = 'row_by_row_icon',
  MultiSelectIcon = 'multi_select_icon',
  SingleSelectIcon = 'single_select_icon',
  DeleteLastIcon = 'delete_last_icon',
  GridIcon = 'grid_icon',
  HomeIcon = 'home_icon',
  HarnessingIcon = 'harnessing_icon',
  ConnectedIcon = 'connected_icon',
  ClockIcon = 'clock_icon',
  ToggleIcon = 'toggle_icon',
  AlertIcon = 'alert_icon',
  ChecklistIcon = 'checklist_icon',
  PauseIcon = 'pause_icon',
  RecordIcon = 'record_icon',
  EulaIcon = 'eula_icon',
  HamburgerIcon = 'hamburger_icon',
  Display2020Icon = 'display_20_20_icon',
  CalendarIcon = 'calendar_icon',
  ConfigCompareIcon = 'config_compare_icon',
  FilterIcon = 'filter_icon',
  AddCircleIcon = 'add_circle_icon',
  AddIcon = 'add_icon',
  SubtractIcon = 'subtract_icon',
  SubtractCircleIcon = 'subtract_circle_icon',
  CloseIcon = 'close_icon',
  CloseCircleIcon = 'close_circle_icon',
  AdjustIcon = 'adjust_icon',
  MeatballIcon = 'meatball_icon',
  MeatballCircleSolidIcon = 'meatball_circle_solid_icon',
  CheckCircleIcon = 'check_circle_icon',
  CheckIcon = 'check_icon',
  CheckboxIcon = 'checkbox_icon',
  SearchIcon = 'search_icon',
  InfoIcon = 'info_icon',
  BellIcon = 'bell_icon',
  BellBadgeIcon = 'bell_badge_icon',
  RefreshIcon = 'refresh_icon',
  EditIcon = 'edit_icon',
  PencilIcon = 'pencil_icon',
  TrashIcon = 'trash_icon',
  FarmIcon = 'farm_icon',
  ClientIcon = 'client_icon',
  DuplicateIcon = 'duplicate_icon',
  PanoramaIcon = 'panorama_icon',
  SwapIcon = 'swap_icon',
  ActiveIcon = 'active_icon',
  AuroraIcon = 'aurora_icon',
  AuroraPanoramaIcon = 'aurora_panorama_icon',
  ClearIcon = 'clear_icon',
  DiagnoseIcon = 'diagnose_icon',
  ProductsIcon = 'products_icon',
  SystemsIcon = 'systems_icon',
  CalibrationsIcon = 'calibrations_icon',
  ChartIcon = 'chart_icon',
  ControlIcon = 'control_icon',
  FieldsIcon = 'fields_icon',
  SettingsIcon = 'settings_icon',
  ChevronIcon = 'chevron_icon',
  CaretIcon = 'caret_icon',
  CompareIcon = 'compare_icon',
  ArrowIcon = 'arrow_icon',
  ArrowCircleIcon = 'arrow_circle_icon',
  RestoreIcon = 'restore_icon',
  SortDescendingIcon = 'sort_descending_icon',
  SortAscendingIcon = 'sort_ascending_icon',
  DownloadIcon = 'download_icon',
  WeblinkIcon = 'weblink_icon',
  UploadIcon = 'upload_icon',
  ExpandChevronsIcon = 'expand_chevrons_icon',
  CollapseChevronsIcon = 'collapse_chevrons_icon',
  TractorIcon = 'tractor_icon',
  PlanterIcon = 'planter_icon',
  SprayerCabIcon = 'sprayer_cab_icon',
  SprayerIcon = 'sprayer_icon',
  PullBehindSprayerIcon = 'pull_behind_sprayer_icon',
  AirSeederIcon = 'air_seeder_icon',
  SidedressIcon = 'sidedress_icon',
  StripTillIcon = 'strip_till_icon',
  CombineCabIcon = 'combine_cab_icon',
  CombineIcon = 'combine_icon',
  PressureIcon = 'pressure_icon',
  ForceIcon = 'force_icon',
  LinearPositionIcon = 'linear_position_icon',
  GranularIcon = 'granular_icon',
  HarvestIcon = 'harvest_icon',
  HybridIcon = 'hybrid_icon',
  LiquidIcon = 'liquid_icon',
  ClosingIcon = 'closing_icon',
  AddPhotoIcon = 'add_photo_icon',
  MapIcon = 'map_icon',
  DetailedMapIcon = 'detailed_map_icon',
  DiagnosticIcon = 'diagnostic_icon',
  LegendIcon = 'legend_icon',
  LassoIcon = 'lasso_icon',
  PinDataIcon = 'pin_data_icon',
  MapToolsIcon = 'map_tools_icon',
  CameraIcon = 'camera_icon',
  FreehandIcon = 'freehand_icon',
  CreateRegionIcon = 'create_region_icon',
  FlagIcon = 'flag_icon',
  FlagPlusIcon = 'flag_plus_icon',
  InsectIcon = 'insect_icon',
  DiseaseIcon = 'disease_icon',
  WeedsIcon = 'weeds_icon',
  ZoomInIcon = 'zoom_in_icon',
  ZoomOutIcon = 'zoom_out_icon',
  DirectionsIcon = 'directions_icon',
  ScissorsIcon = 'scissors_icon',
  CrosshairSquareIcon = 'crosshair_square_icon',
  CrosshairIcon = 'crosshair_icon',
  CrosshairSolidIcon = 'crosshair_solid_icon',
  LocateSolidIcon = 'locate_solid_icon',
  LocateIcon = 'locate_icon',
  LocateSlashIcon = 'locate_slash_icon',
  LayersIcon = 'layers_icon',
  SplitMapIcon = 'split_map_icon',
  SplitMapHalfIcon = 'split_map_half_icon',
  SplitMapFullIcon = 'split_map_full_icon',
  VisionCameraIcon = 'vision_camera_icon',
  EmergenceIcon = 'emergence_icon',
  FillIcon = 'fill_icon',
  GenerateIcon = 'generate_icon',
  PolygonIcon = 'polygon_icon',
  RectangleIcon = 'rectangle_icon',
  BoundaryCircleIcon = 'boundary_circle_icon',
  LocationIcon = 'location_icon',
  FileIcon = 'file_icon',
  DisplayConfigurationIcon = 'display_configuration_icon',
  DbmIcon = 'dbm_icon',
  ThirdPartySetupIcon = 'third_party_setup_icon',
  Gen2SetupIcon = 'gen_2_setup_icon',
  HistoryIcon = 'history_icon',
  ConnectivityIcon = 'connectivity_icon',
  PowerIcon = 'power_icon',
  UsbIcon = 'usb_icon',
  NoteIcon = 'note_icon',
  PairDeviceIcon = 'pair_device_icon',
  CreditCardIcon = 'credit_card_icon',
  DataShareIcon = 'data_share_icon',
  FeedbackIcon = 'feedback_icon',
  LockIcon = 'lock_icon',
  MembersIcon = 'members_icon',
  OverviewIcon = 'overview_icon',
  CloudArrowIcon = 'cloud_arrow_icon',
  ArchiveIcon = 'archive_icon',
  UnarchiveIcon = 'unarchive_icon',
  DataManagementIcon = 'data_management_icon',
  TankLevelLiquidIcon = 'tank_level_liquid_icon',
  TankLevelIcon = 'tank_level_icon',
  FieldBoundariesIcon = 'field_boundaries_icon',
  PrescriptionOutlineIcon = 'prescription_outline_icon',
  PrescriptionIcon = 'prescription_icon',
  InternalFieldBoundariesIcon = 'internal_field_boundaries_icon',
  ConnectivityHardwareIcon = 'connectivity_hardware_icon',
  GuidanceStraightIcon = 'guidance_straight_icon',
  GuidanceCircleIcon = 'guidance_circle_icon',
  GuidanceIcon = 'guidance_icon',
  GuidanceCornersRoundedIcon = 'guidance_corners_rounded_icon',
  GuidanceCornersIcon = 'guidance_corners_icon',
  GuidanceBoundaryIcon = 'guidance_boundary_icon',
  GuidanceCurveIcon = 'guidance_curve_icon',
  GuidanceHeadingIcon = 'guidance_heading_icon',
  GuidanceBoundaryLineIcon = 'guidance_boundary_line_icon',
  GuidanceCreatedLineIcon = 'guidance_created_line_icon',
  GuidancePassesIcon = 'guidance_passes_icon',
  GuidanceHeadlandsIcon = 'guidance_headlands_icon',
  PlanIcon = 'plan_icon',
  CoverageIcon = 'coverage_icon',
  SpeedIcon = 'speed_icon',
  WeatherIcon = 'weather_icon',
  PrintIcon = 'print_icon',
  DragIcon = 'drag_icon',
  HeadingDegreeIcon = 'heading_degree_icon',
  CopyIcon = 'copy_icon',
  ClickIcon = 'click_icon',
  MicrophoneIcon = 'microphone_icon',
  MicrophoneSlashIcon = 'microphone_slash_icon',
  VolumeIcon = 'volume_icon',
  VolumeSlashIcon = 'volume_slash_icon',
  WindDirectionIcon = 'wind_direction_icon',
  SatelliteIcon = 'satellite_icon',
  CircleIcon = 'circle_icon',
  ThumbsUpIcon = 'thumbs_up_icon',
  ThumbsDownIcon = 'thumbs_down_icon'
}

export enum SpriteMap16 {
  Hamburger16 = 'hamburger_16',
  AddCircle16 = 'add_circle_16',
  CloseCircle16 = 'close_circle_16',
  CheckCircle16 = 'check_circle_16',
  CheckCircleFilled16 = 'check_circle_filled_16',
  Check16 = 'check_16',
  Swap16 = 'swap_16',
  Active16 = 'active_16',
  Settings16 = 'settings_16',
  Chevron16 = 'chevron_16',
  Restore16 = 'restore_16',
  SortDescending16 = 'sort_descending_16',
  SortAscending16 = 'sort_ascending_16',
  Download16 = 'download_16',
  Weblink16 = 'weblink_16',
  Upload16 = 'upload_16',
  ExpandChevrons16 = 'expand_chevrons_16',
  CrosshairSquare16 = 'crosshair_square_16',
  Archive16 = 'archive_16',
  DataManagement16 = 'data_management_16'
}

export enum SpriteMapCustom {
  FlagCustom = 'flag_custom',
  InsectCustom = 'insect_custom',
  DiseaseCustom = 'disease_custom',
  WeedsCustom = 'weeds_custom',
  EmergenceCustom = 'emergence_custom'
}

export enum SpriteMapPredefined {
  PoorPredefined = 'poor_predefined',
  FailPredefined = 'fail_predefined',
  GoodPredefined = 'good_predefined',
  UnexpectedPredefined = 'unexpected_predefined',
  NotReadyPredefined = 'not_ready_predefined',
  UpdatingPredefined = 'updating_predefined',
  DisabledPredefined = 'disabled_predefined',
  DetectingPredefined = 'detecting_predefined',
  CompassPredefined = 'compass_predefined',
  PrecisionPlantingLogoLightPredefined = 'precision_planting_logo_dark_predefined',
  PrecisionPlantingLogoDarkPredefined = 'precision_planting_logo_light_predefined',
  PointAOutlinePredefined = 'point_a_outline_predefined',
  PointBOutlinePredefined = 'point_b_outline_predefined',
  AggregateTotalsPredefined = 'aggregate_totals_predefined',
  LegendPredefined = 'legend_predefined',
  SortChevronsPredefined = 'sort_chevrons_predefined',
  PointAPredefined = 'point_a_predefined',
  PointBPredefined = 'point_b_predefined',
  AuroraPanoramaPredefined = 'aurora_panorama_predefined'
}
